// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-indicator-container {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.loading-indicator-container .spinner-grow {
  width: 4rem;
  height: 4rem;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/components/loading/loading-indicator.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;AAAF;AAEE;EACE,WAAA;EACA,YAAA;AAAJ","sourcesContent":[".loading-indicator-container {\r\n  width: 100%;\r\n  height: 100vh;\r\n\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n\r\n  .spinner-grow{\r\n    width: 4rem;\r\n    height: 4rem;\r\n  }\r\n\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
